<div class="modal-header">
  <h4 class="modal-title pull-left">Confirm Assignee</h4>
  <div aria-label="Close" (click)="onCancel()" class="close pull-right">
    <span aria-hidden="true">×</span></div>
</div>

<div class="modal-body">
  <b>Do you want to assign yourself as Processor for this Report?</b>
</div>

<div class="modal-footer">
  <button class="btn btn-rbv default" (click)="onCancel()">Cancel</button>
  <button class="btn btn-rbv" (click)="onConfirm()">Yes</button>
</div>
